import React from "react"
import {GameModes} from "../../../../constants/EnumGameModes";
import {GameModePage} from "../../GameModePage";


export const SoloClassic: React.FC = () => {
    return (
        <GameModePage
            gameMode={GameModes.CLASSIC_SOLO}
            showDifficultySelector={true}
            showBreadcrumb={true}
            containerPadding="xl:px-44"
        />
    );
}
